import { connect } from 'react-redux'
import * as customerSelector from '../../../customer/state/detail/selector'
import * as action from '../../state/match/action'
import * as selector from '../../state/match/selector'
import Match3ShapeCustomer from '../match/Match3ShapeCustomer'
import * as processSelector from '../../../process/state/instance-detail/selector'
import * as processAction from '../../../process/state/instance-detail/action'

const mapStateToProps = (state, props) => {
    return {
        customer: customerSelector.selectCustomer(state),
        caseList: selector.selectCaseList(state),
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    findUnassignedCaseList: action.findUnassignedCaseList,
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(Match3ShapeCustomer)



// WEBPACK FOOTER //
// ./src/modules/threeshape/component/task-widget/Match3ShapeCustomerWidgetContainer.js